// extracted by mini-css-extract-plugin
export default {"wrapper":"ColorPicker_wrapper__x7Fwz","color":"ColorPicker_color__naD2r","picker":"ColorPicker_picker__XizsB","close_wrapper":"ColorPicker_close_wrapper__sjHxC"};